// src/ConsumerApp/api/savedList/savedList.service.js
import { apiClient } from '../apiClient';

export const SavedListService = {
  /**
   * Fetch the complete saved list for a customer (includes item details)[cite: 46]
   */
  getSavedList: async (customerId) => {
    const response = await apiClient.get(
      `/brickbucket/customer/saved-list/get-saved-list?customer_id=${customerId}`
    );
    return response.data || response;
  },

  /**
   * Fetch lightweight version of the saved list[cite: 46]
   */
  getSavedListWithoutDetails: async (customerId) => {
    const response = await apiClient.get(
      `/brickbucket/customer/saved-list/get-saved-list-without-details?customer_id=${customerId}`
    );
    return response.data || response;
  },

  /**
   * Add item to saved list[cite: 46]
   */
  addItemToSavedList: async (payload) => {
    const response = await apiClient.post(
      '/brickbucket/customer/saved-list/add-item-to-saved-list',
      payload
    );
    return response.data || response;
  },

  /**
   * Remove item from saved list[cite: 46]
   */
  removeItemFromSavedList: async (payload) => {
    const response = await apiClient.delete(
      '/brickbucket/customer/saved-list/remove-item-from-saved-list',
      { data: payload }
    );
    return response.data || response;
  },
};